module.exports = __webpack_public_path__ + "img/f6.c99503c8.png";